import React, { useState } from 'react';
import { ProfilesTabParamList, useGoBack } from '../../../../../utils/appNavigationNames';
import useNotes from '../../../../../hooks/api/useNotes';
import { RouteProp } from '@react-navigation/native';
import TransferNote from '../../../../shared/Notes/TransferNote';
import { noteFileToNotModified } from '../../../../shared/Notes/utils/noteFileToNoteModified';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';

export type NoteTransferScreenOwnProps = {};

export type NoteTransferScreenProps = NoteTransferScreenOwnProps & {
    route: RouteProp<ProfilesTabParamList, 'transfer-note'>;
};

const NoteTransferScreen: React.FC<NoteTransferScreenProps> = (props) => {
    const goBack = useGoBack();
    const [notesKey, setNotesKey] = useState(0);
    const { note, isLoadingNote, updateUserNote, isUpdatingUserNote } = useNotes({
        noteId: props.route.params.noteId,
        onUpdateSuccess: (drySubmit) => {
            if (drySubmit) {
                setNotesKey((prevKey) => prevKey + 1);
                return;
            }
            goBack();
        },
    });

    return (
        <AnimateLoadedContent isLoading={isLoadingNote || !note}>
            {() => (
                <TransferNote
                    key={notesKey}
                    note={note!}
                    onTransfer={(destination) => {
                        updateUserNote({
                            drySubmit: false,
                            note: {
                                ...note!,
                                files: note!.files.map(noteFileToNotModified),
                                images: note!.images.map(noteFileToNotModified),
                                ...destination,
                            },
                            noteId: props.route.params.noteId,
                        });
                    }}
                    isTransferring={isUpdatingUserNote}
                />
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(NoteTransferScreen);
